<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="图片名称：">
            <el-input v-model="query.name" placeholder="请输入图片名称" clearable size="small" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="op-btn">
          <el-button type="primary" size="mini" plain @click="handleCreate">上传</el-button>
          <el-button type="primary" size="mini" plain @click="handleDeleteBatch">批量删除</el-button>
        </div>
      </div>
      <div class="demo-image">
        <div class="img-list" v-for="(fit,index) in list" :key="index">
          <el-image style="width: 160px; height: 160px" fit="cover" :src="fit.url"></el-image>
          <el-image-viewer v-if="showViewer" :on-close="()=>{showViewer=false}" :url-list="previewList" />
          <br />
          <div class="opea-icon">
            <i class="el-icon-view" @click="handlePreview(fit)"></i>
            <i class="el-icon-download" @click="handleDownload(fit)"></i>
            <i class="el-icon-edit" @click="handleUpdate(fit)"></i>
            <i class="el-icon-delete" @click="handleDeleteSingle(fit)"></i>
          </div>
          <div class="fit-name">{{fit.name}}</div>
          <div class="ellip">
            <el-checkbox v-model="fit.checked"></el-checkbox>
          </div>

        </div>
      </div>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <main-image-add ref="mainImageAdd" @created="doQueryList({})" />
    <main-image-edit ref="mainImageEdit" @created="doQueryList({})" />
  </div>
</template>

<script>
import mainImageApi from '@/api/meeting/mainImage'
import Pagination from '@/components/Pagination'
import mainImageAdd from './add.vue'
import mainImageEdit from './edit.vue'
export default {
  components: {
    Pagination,
    mainImageAdd,
    mainImageEdit,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 20,
        name: undefined,
        orderNoSortSign: 1
      },
      imageList: [],
      selectItems: [],
      previewList: [],
      showViewer: false,
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    //预览
    handlePreview(item) {
      let arr = [];
      arr.push(item.url);
      this.previewList = arr;
      this.showViewer = true;
    },
    download(href, name) {
      let eleLink = document.createElement('a')
      eleLink.download = name
      eleLink.href = href
      eleLink.click()
      eleLink.remove()
    },
    //下载
    handleDownload(item) {
      let that = this;
      let image = new Image()
      image.src = item.url + '?tamp=' + (new Date()).valueOf();
      image.crossOrigin = 'Anonymous';
      image.onload = () => {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        canvas.toBlob((blob) => {
          let url = URL.createObjectURL(blob)
          that.download(url, item.name)
          // 用完释放URL对象
          URL.revokeObjectURL(url)
        })
      }
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return mainImageApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDeleteBatch() {
      let arr = []
      this.list.forEach(it => {
        if (it.checked) arr.push(it.id)
      })
      if (arr.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm(`当前选择${arr.length}条数据，是否确认删除`)
        .then(() => mainImageApi.deleteBatch(arr))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({})
        })
    },
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => mainImageApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({})
        })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      questionsApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.mainImageAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.mainImageEdit.handleUpdate(row)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-container {
  position: relative;
  .op-btn {
    float: right;
    position: absolute;
    right: 0;
    top: 5px;
  }
}
.demo-image {
  margin-top: 15px;
  .img-list {
    padding: 15px;
    text-align: center;
    display: inline-block;
    position: relative;
    font-size: 0;
    // width: 12.5%;
    .ellip {
      position: absolute;
      left: 20px;
      top: 20px;
    }
    .fit-name {
      width: 160px;
      font-size: 14px;
      overflow: hidden;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .opea-icon {
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(3, 14, 29, 0.6);
      position: absolute;
      bottom: 30px;
      left: 15px;
      right: 15px;
      padding: 0 10px;
      
      i {
        position: relative;
        z-index: 12;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        &.el-icon-delete {
          color: #da251e;
        }
      }
    }
  }
}
</style>
